module.exports = __webpack_public_path__ + "img/web_coaches_top.315b9211.jpg";